/**
 * E.1 — rascunho LLM na Central via bridge Hermes (mesma org/modelo/quota do Chat).
 * Fallback = motor de regras em sugestao.ts.
 */
import { pedirAnaliseProposta } from '../../api/bridge'
import type { CasoMl, FilaShopee } from './logic'
import type { Sugestao, SugestaoShopee } from './sugestao'

export type RascunhoIa = {
  ok: boolean
  fonte?: 'llm' | 'regras'
  modelo?: string | null
  texto?: string | null
  erro?: string
  gerado_em?: string
}

async function postRascunho(body: Record<string, unknown>): Promise<RascunhoIa> {
  const data = await pedirAnaliseProposta({
    tipo: 'rascunho_reclamacao',
    ...body,
  })
  if (!data.ok) {
    return {
      ok: false,
      erro: data.message || data.error || data.motivo || 'falha ao gerar rascunho',
    }
  }
  return {
    ok: true,
    fonte: data.fonte === 'llm' ? 'llm' : 'regras',
    modelo: data.modelo,
    texto: data.texto,
    gerado_em: data.gerado_em,
  }
}

export function pedirRascunhoMl(caso: CasoMl, regras: Sugestao): Promise<RascunhoIa> {
  return postRascunho({
    canal: 'mercado_livre',
    caso: {
      id: caso.id,
      conta: caso.conta,
      motivoCod: caso.motivoCod,
      motivoLabel: caso.motivoLabel,
      hot: caso.hot,
      valor: caso.valor,
      itemTitulo: caso.itemTitulo,
      mlb: caso.mlb,
      aberta: caso.aberta,
      temPrazo: caso.temPrazo,
      noPrazo: caso.noPrazo,
    },
    regras: {
      conduta: regras.conduta,
      porque: regras.porque,
      texto: regras.texto,
      avisos: regras.avisos,
      base: regras.base,
      chance: regras.chance,
    },
    mensagens: caso.mensagensDetalhe || [],
  })
}

export function pedirRascunhoShopee(caso: FilaShopee, regras: SugestaoShopee): Promise<RascunhoIa> {
  return postRascunho({
    canal: 'shopee',
    caso: {
      sn: caso.sn,
      loja: caso.loja,
      status: caso.status,
      motivoCod: caso.motivoCod,
      valor: caso.valor,
      produto: caso.produto,
      pendente: caso.pendente,
      textoComprador: caso.texto,
    },
    regras: {
      conduta: regras.conduta,
      porque: regras.porque,
      texto: regras.texto,
      avisos: regras.avisos,
      base: regras.base,
      tne: regras.tne,
    },
    mensagens: caso.texto ? [{ de: 'comprador', texto: caso.texto }] : [],
  })
}
